<template>
  <div>
    <div class="row mt-4">
      <div class="col-sm-6">
        <h5 class="mb-3">{{ $t('marketplace.rma_product.filter_option') }}</h5>
        <b-form v-if="show">
          <div class="form-group row">
            <label for="" class="col-sm-3 col-form-label">{{ $t('marketplace.rma_product.return_requested_at') }}</label>
            <div class="col-sm-9 row">
              <div class="col-sm-6 form-row">
                <datepicker v-model="filter.returnRequestedFrom" placeholder="YYYY-MM-DD" :format="customFormatter" input-class="form-control"></datepicker>
              </div>
              <div class="col-sm-6 form-row">
                <datepicker v-model="filter.returnRequestedTo" placeholder="YYYY-MM-DD" :format="customFormatter" input-class="form-control"></datepicker>
              </div>
            </div>
          </div>
          <b-form-fieldset
            :label="$t('marketplace.rma_product.document_no')"
            :label-cols="3"
            :horizontal="true">
            <b-form-input type="text" v-model="filter.document_no" :placeholder="$t('marketplace.rma_product.please_enter_document_no')"></b-form-input>
          </b-form-fieldset>
          <b-form-fieldset
            :label="$t('marketplace.rma_product.platform')"
            :label-cols="3"
            :horizontal="true">
            <select class="form-control" v-model.trim="filter.platform">
              <option :value="null" key="Please select an platform">Please select an platform</option>
              <option v-for="(marketplace, index) in marketplaces" :value="marketplace.name" :key="index">{{ marketplace.name }}</option>
            </select>
          </b-form-fieldset>
          <b-form-fieldset
            :label="$t('marketplace.rma_product.platform_order_id')"
            :label-cols="3"
            :horizontal="true">
            <b-form-input type="text" v-model="filter.platform_order_id" :placeholder="$t('marketplace.rma_product.please_enter_platform_order_id')"></b-form-input>
          </b-form-fieldset>
          <b-form-fieldset
            :label="$t('marketplace.rma_product.imei_code')"
            :label-cols="3"
            :horizontal="true">
            <b-form-input type="text" v-model="filter.imei_code" :placeholder="$t('marketplace.rma_product.please_enter_imei_code')"></b-form-input>
          </b-form-fieldset>
          <b-form-fieldset
            :label="$t('marketplace.rma_product.product_name')"
            :label-cols="3"
            :horizontal="true">
            <b-form-input type="text" v-model="filter.product_name" :placeholder="$t('marketplace.rma_product.please_enter_product_name')"></b-form-input>
          </b-form-fieldset>

          <b-form-fieldset
            :label="$t('marketplace.rma_product.conditions')"
            :label-cols="3"
            :horizontal="true">
            <select class="form-control" v-model.trim="filter.conditions">
              <option :value="null" key="1">Please select a Condition</option>
              <option value="Good Condition" key="2">Good Condition</option>
              <option value="Like New" key="3">Like New</option>
              <option value="Damage" key="4">Damage</option>
            </select>
          </b-form-fieldset>
          <b-form-fieldset
            :label="$t('marketplace.rma_product.status')"
            :label-cols="3"
            :horizontal="true">
            <select class="form-control" v-model.trim="filter.status">
              <option :value="null" key="Please select status">Please select status</option>
              <option value=9 key="Return">Return Request</option>
              <option value=1 key="Received">Received</option>
              <option value=2 key="InProgress">Sold In Progress</option>
              <option value=3 key="Settled">Settled</option>
              <option value=99 key="Lost">Lost</option>
            </select>
          </b-form-fieldset>
          <b-button type="button" size="sm" variant="primary" @click="onSearchForm"><i class="fa fa-search"></i> {{ $t('marketplace.rma_product.search') }}</b-button>
          <b-button type="reset" size="sm" variant="danger ml-1" @click="onReset"><i class="fa fa-ban"></i> {{ $t('marketplace.rma_product.reset') }}</b-button>
          <b-button size="sm" variant="warning ml-1" @click="downloadFilterRmaProducts()"><i class="fa fa-download"></i>&nbsp; Export Filtered RMA</b-button>
        </b-form>
      </div><!--col-->
    </div>
  </div>
</template>

<script>
import datepicker from 'vuejs-datepicker'
import moment from 'moment'
import FileSaver from 'file-saver'

export default {
  name: 'RmaProductFilters',
  props: {
    filter: {
      type: Object
    },
    fetchRmaProducts: {
      type: Function
    }
  },
  components: {
    datepicker
  },
  mounted () {
    this.axios.get('/marketplace/platform').then(response => {
      this.marketplaces = response.data
    }).catch(error => {
      console.log(error)
    })
  },
  data () {
    return {
      marketplaces: [],
      show: true
    }
  },
  methods: {
    onReset () {
      // evt.preventDefault()
      this.filter.platform_order_id = ''
      this.filter.imei_code = ''
      this.filter.product_name = ''
      this.filter.document_no = ''
      this.filter.platform = null
      this.filter.status = null
      this.filter.conditions = null
      this.filter.returnRequestedFrom = null
      this.filter.returnRequestedTo = null
      this.show = false
      this.$nextTick(() => { this.show = true })
    },
    customFormatter (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    async downloadFilterRmaProducts () {
      this.axios.get('/marketplace/rma-product/download-rma', {
        params: {
          platform_order_id: this.filter.platform_order_id,
          imei_code: this.filter.imei_code,
          product_name: this.filter.product_name,
          document_no: this.filter.document_no,
          platform: this.filter.platform,
          status: this.filter.status,
          conditions: this.filter.conditions,
          return_request_from: this.filter.returnRequestedFrom,
          return_request_to: this.filter.returnRequestedTo,
        },
        responseType: 'blob'
      }).then((response) => {
        FileSaver.saveAs(response, moment().format('YYYY-MM-DD') + '-rma-products.xlsx')
      })
    },
    onSearchForm () {
      this.fetchRmaProducts({
        params: {
          platform_order_id: this.filter.platform_order_id,
          imei_code: this.filter.imei_code,
          product_name: this.filter.product_name,
          document_no: this.filter.document_no,
          platform: this.filter.platform,
          status: this.filter.status,
          conditions: this.filter.conditions,
          return_request_from: this.filter.returnRequestedFrom,
          return_request_to: this.filter.returnRequestedTo,
          page: 1
        }
      })
    }
  }
}
</script>